export const formSubmissionHandler = {
    pathPattern: '/brands/:brandId/website/forms/:formId/submissions/:submissionId',
    toWeb: ({ brandId, formId, submissionId }) => ({
        path: `/brands/${brandId}/website/forms/${formId}/submissions/${submissionId}`,
    }),
    meta: {
        title: 'Form submission',
        description: 'Opens a website form submission in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'formId', in: 'path', required: true },
            { name: 'submissionId', in: 'path', required: true },
        ],
        example: {
            params: {
                brandId: 'BXqExampleBrandId',
                formId: 'exampleFormId',
                submissionId: 'exampleSubmissionId',
            },
        },
    },
};
//# sourceMappingURL=form-submission.js.map